import { SlideFrame } from '../SlideFrame';

// Borrowed authority — Ackman's CNBC line (May 2026) makes the
// "AI is not optional" point so we don't have to assert it. Sets up
// the Visualizer reveal on Slide 5. Banner echoes the "analytical
// partner for critical decisions" frame from the deck's broader narrative.
export function Slide04Ackman() {
  return (
    <SlideFrame pageNum={4} title="THE INDUSTRY IS CHANGING"
      banner="We agree. So we built the Visualizer to be our analytical partner for critical decisions.">
      <div className="h-full flex flex-col justify-center items-center px-16">
        <div className="text-center max-w-5xl -translate-y-[1cm]">
          <div className="text-[#c9a84c] text-[120px] leading-none font-serif opacity-50 mb-2">&ldquo;</div>
          <p className="text-white font-serif italic text-[44px] leading-tight tracking-tight">
            Every company is an AI company today.
          </p>
          <p className="text-white font-serif italic text-[44px] leading-tight tracking-tight mt-2">
            If you&rsquo;re not, you&rsquo;re going to fall behind.
          </p>
          <div className="mt-8 text-[#94a3b8] text-[16px] tracking-wider">
            BILL ACKMAN
            <span className="text-[#64748b] mx-3">&middot;</span>
            CNBC MONEY MOVERS
            <span className="text-[#64748b] mx-3">&middot;</span>
            MAY 2026
          </div>
        </div>
      </div>
    </SlideFrame>
  );
}
